import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Dashboard from "./modules/Dashboard";
import AuthPage from "./modules/AuthPage";
import ProjectDetails from "./components/ProjectDetails";
import { ProjectProvider } from "./modules/ProjectContext";
import MiniDrawer from "./modules/MiniDrawer";
import FaqPage from "./modules/FaqPage";
import GuidePage from "./modules/GuidePage";

function useUrlShopifyToken() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let shopifyToken = params.get("token");

    if (!shopifyToken && location.hash) {
      const hashParams = new URLSearchParams(location.hash.substring(1)); // remove #
      shopifyToken = hashParams.get("linkToken");
    }

    if (shopifyToken) {
      console.log("Captured shopifyToken:", shopifyToken);
      sessionStorage.setItem("shopifyToken", shopifyToken);

      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);
}

function AppRoutes() {
  useUrlShopifyToken();

  const authToken = sessionStorage.getItem("authToken");

  return (
    <Routes>
      <Route path="/auth" element={<AuthPage />} />

      {/* FAQ is always accessible */}
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/getting" element={<GuidePage />} />

      {authToken ? (
        <Route element={<MiniDrawer />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/projects" element={<ProjectDetails />} />
          <Route path="/guide" element={<GuidePage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/auth" replace />} />
      )}
    </Routes>
  );
}

export default function App() {
  return (
    <ProjectProvider>
      <Router>
        <AppRoutes />
      </Router>
    </ProjectProvider>
  );
}
